import type { Condition } from './condition.type.ts';

// Right now we don't support other provinces/classifications but we likely will in the future.
export interface ConditionExtension extends Condition {}
export class ConditionExtension {
  get staticJsonAssetName() {
    if (!this.filename) {
      return '';
    }
    return this.filename.split('.json')[0] || '';
  }

  get hasPdf() {
    return !!this.publicAssets?.length;
  }

  get pdfUrl() {
    return this.publicAssets?.[0]?.signedUrl || '';
  }
}

const Registration = {
  kind: 'object',
  name: 'condition',
  features: ConditionExtension,
};
export default Registration;
